// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  encounterId: __t.u64().name("encounter_id"),
  fixture: __t.u16(),
  stash: __t.u8(),
  openedBy: __t.u64().name("opened_by"),
  def: __t.u16(),
  tier: __t.u8(),
  name: __t.string(),
  relic: __t.bool(),
  value: __t.u32(),
  pile: __t.option(__t.u32()),
  itemId: __t.option(__t.u64()).name("item_id"),
});
